// @TODO: implement bundle splitting here for pym
import { Parent } from "pym.js";

import { FB_JS_SDK_VERSION } from "config/constants";

const renderXFBML = block => {
  const element = document.querySelector(`.block-${block.key}`);
  window.FB.XFBML.parse(element);
};

const attachJWListeners = (htmlId, mediaId, isAutoplay) => {
  // JW Player JS documentation
  // https://developer.jwplayer.com/jw-player/docs/javascript-api-reference/
  const player = window.jwplayer(htmlId);
  let gtmTimeout;
  let gtmCalled = false;

  player.on("firstFrame", () => {
    // Turn on captions by default when the player starts playing.
    // Axios currently only uploads (and plans to upload) one captions track 2/2/2018
    // Note from JW: The caption at index of 0 will always be "off" and will always be returned even if no captions are present.
    // To turn off captions, use setCurrentCaptions(0)
    if (player.getCaptionsList().length > 1) {
      player.setCurrentCaptions(1);
    }
  });

  player.on("play", () => {
    // Ping GTM if a video is played for longer than 3s
    // This is a JPMC KPI for Smarter Faster
    if (!gtmCalled) {
      gtmTimeout = setTimeout(() => {
        window.dataLayer.push({ mediaId, event: "jw-player-3s-viewed" });
        gtmCalled = true;
      }, 3000);
    }
  });

  player.on("pause", () => {
    // Clear 3s-viewed timeout if a video pauses
    // A pauses event fires if a user scrolls out of view
    clearTimeout(gtmTimeout);
  });

  player.on("viewable", e => {
    // JW emits an event whenever a player scrolls in or out of view.
    // Play videos if they scroll into view
    // Pause if they scroll out of view
    if (e.viewable === 0) {
      player.pause(true);
    } else if (e.viewable === 1 && isAutoplay) {
      player.play(true);
    }
  });

  // player.on("playAttemptFailed", () => {
  //   player.stop();
  // });
};

export const handleEmbed = block => {
  const { type } = block.data;

  switch (type) {
    case "facebook-post":
    case "facebook-video": {
      // Facebook sdk.js documentation
      // https://developers.facebook.com/docs/javascript
      // If Facebook's JS hasn't loaded, append it to the body of the doc,
      // then add an init function once it loads which renders embeds.
      // Otherwise, use FB's JS to render embeds
      if (!window.FB) {
        const script = document.createElement("script");
        script.setAttribute(
          "src",
          `//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v${FB_JS_SDK_VERSION}`
        );
        document.body.appendChild(script);
        window.fbAsyncInit = () => {
          window.FB.init({ version: `v${FB_JS_SDK_VERSION}`, xfbml: true });
          renderXFBML(block);
        };
      } else {
        renderXFBML(block);
      }
      break;
    }
    case "instagram": {
      // Instagram embed documentation
      // https://www.instagram.com/developer/embedding/
      let instgrm = window.instgrm;
      if (instgrm) instgrm.Embeds.process();
      break;
    }
    default:
      break;
  }
};

/** Lazyloading */
const lazyLoadTwitter = e => {
  // Twitter embed documentation
  // https://dev.twitter.com/web/embedded-tweets#render-a-tweet-with-javascript
  if (twttr && twttr.widgets && twttr.widgets.load)
    twttr.widgets.load(e.target);
};

const lazyLoadAxiosVisual = e => {
  const { slug, url } = e.target.dataset;
  new Parent(slug, url);
};

const lazyLoadJW = e => {
  // JW Player JS documentation
  // https://developer.jwplayer.com/jw-player/docs/javascript-api-reference/
  const { media, player, autoplay } = e.target.dataset;
  const isAutoplay = autoplay === "true";
  const htmlId = `botr_${media}_${player}_div`;

  if (typeof document === "object") {
    const jwEmbedScript = document.createElement("script");
    jwEmbedScript.setAttribute(
      "src",
      `https://content.jwplatform.com/players/${media}-${player}.js`
    );
    jwEmbedScript.setAttribute("type", "text/javascript");
    const jwElement = document.getElementById(`jw-${media}`);

    if (jwElement) {
      jwElement.appendChild(jwEmbedScript);
    }

    jwEmbedScript.onload = () => {
      attachJWListeners(htmlId, media, isAutoplay);
    };
  }
};

const handleLazyLoad = event => {
  switch (event.target.dataset.type) {
    case "axios-visual":
      lazyLoadAxiosVisual(event);
      break;
    case "twitter":
      lazyLoadTwitter(event);
      break;
    case "jwplayer-video":
      lazyLoadJW(event);
      break;
    default:
      break;
  }
};

export const lazyLoadListener = event => handleLazyLoad(event);

if (typeof window !== "undefined") {
  window.addEventListener("lazybeforeunveil", lazyLoadListener);
}
